import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const MensagemWarning = ({ open, handleClose, msg }) => {
  const message =
    typeof msg === "string"
      ? msg
      : typeof msg === "object" && msg !== null
      ? JSON.stringify(msg)
      : String(msg || "Processando...");

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity="warning">
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MensagemWarning;
